import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {}
